<template lang="html">

    <div class="slds-form-element slds-form-element_stacked" v-bind:class="{ 'slds-form-element_readonly': disabled, 'slds-has-error': errormsg }">
      
      <div v-if="type=='null'">
      </div>

      <div v-if="disabled && type!='null'">
        <span class="slds-form-element__label">{{$t(title)}}</span>
          <div class="slds-form-element__control">
            <div class="slds-form-element__static">
              <span v-if="type=='text' || type=='picklist' " v-html="value"></span>
              <span v-if="type=='number' || type=='currency' || type=='date' || type=='datetime'">{{value | filter(type)}}</span>
            </div>
          </div>
      </div>

      <div v-if="!disabled && type!='null'">

        <label v-if=" type!='checkbox' && type!='picklist' " class="slds-form-element__label" v-bind:for="'form-element-'+tabindex">{{$t(title)}}</label>

<div v-if="tip" class="slds-form-element__icon">
    <button class="slds-button slds-button_icon" aria-describedby="help" v-on:mouseenter="showtip=true" v-on:mouseleave="showtip=false">
      <svg class="slds-button__icon" aria-hidden="true">
        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#info"></use>
      </svg>
      <span class="slds-assistive-text">Help</span>
    </button>
    <div v-if="showtip"  class="slds-popover slds-popover_tooltip slds-nubbin_bottom-left" role="tooltip" id="help" style="position:absolute;top:-45px;left:-15px;width:170px">
      <div class="slds-popover__body">{{tip}}</div>
    </div>
  </div>


        <div v-if="type=='text' || type=='number' " class="slds-form-element__control">
          <input v-on:change="$emit('change',$event.target.value)" v-bind:value="value" v-bind:type="type" v-bind:id="'form-element-'+tabindex" v-bind:placeholder="$t(placeholder)" class="slds-input" />
        </div>

        <div v-if="type=='textarea' || type=='number' " class="slds-form-element__control">
          <textarea v-on:change="$emit('change',$event.target.value)" v-bind:value="value" v-bind:type="type" v-bind:id="'form-element-'+tabindex" v-bind:placeholder="$t(placeholder)" class="slds-input" />
        </div>

        <div v-if="type=='checkbox' " >
          <fieldset class="slds-form-element slds-form-element_horizontal">
              <legend v-if="false" class="slds-form-element__legend slds-form-element__label">{{$t(title)}}</legend>
              <div class="slds-form-element__control">
                <div v-on:click="$emit('change', !value)" class="slds-checkbox">
                    <input v-bind:value="value" v-bind:checked="value" v-bind:type="type" v-bind:id="'form-element-'+tabindex"  />
                    <label class="slds-checkbox__label" for="checkbox-103">
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label">{{$t(title)}}</span>
                    </label>
                </div>
              </div>
          </fieldset>
        </div>

        <div v-if="type=='picklist' " >
          <formpicklist
            v-bind:id="id"
            v-bind:title="$t(title)"
            v-bind:type="type"
            v-bind:value="value"
            v-bind:placeholder="$t(placeholder)"
            v-bind:tabindex="tabindex"
            v-bind:disabled="disabled"
            v-bind:options="options"
            v-bind:hform="hform"
            v-on:change="$emit('change', $event)"
            />
        </div>

        <div v-if="type=='gmapaddress' " >
          <gmapaddress
            v-bind:id="id"
            v-bind:title="$t(title)"
            v-bind:value="value"
            v-bind:placeholder="$t(placeholder)"
            v-bind:tabindex="tabindex"
            v-bind:disabled="disabled"
            v-on:change="$emit('change', $event)"
            />
        </div>

        <div v-if="type=='date' " class="slds-form-element__control">
          <input v-on:change="$emit('change',$event.target.value)" v-bind:value="value" v-bind:type="type" v-bind:id="'form-element-'+tabindex" v-bind:placeholder="$t(placeholder)" class="slds-input" />
        </div>

        <div class="slds-form-element__help" v-if="errormsg">{{errormsg}}</div>
      </div>


    </div>

</template>

<script>
import formpicklist from './picklist.vue'
import gmapaddress from './gmapaddress.vue'
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import numeral from 'numeral'
import moment from 'moment'

  export default {
    name: 'gnetFormField2',
    components: {
      formpicklist,
      gmapaddress,
//      VueCtkDateTimePicker
     },
    props: {
      id: String,
      value: [String, Number, Date, Boolean],
      title: String,
      type: String,
      tabindex: Number,
      disabled: Boolean,
      placeholder: String,
      options: Array,
      hform: Boolean,
      format: String,
      errormsg: String,
      tip: String
    },
    filters: {
      filter: function(v, type) {
        switch(type) {
          case 'date':
            var n=new moment(v);
            return n.format('DD/MM/YYYY');
          case 'currency':
            return numeral(v).format('$ 0,0.00');
          case 'alert':
              return v;
        }
        return v;
      }
    },
    data() {
      return {
        showtip:false
      }
    },
    computed: {},
    async created() {},
    methods: {}
  }

</script>

<style scoped>

</style>
